// DE profile › KPIs (AGENT-MENTION, review #13; filled in wave 11b): KPI-ASSIGN's SeatKpisPanel
// for the DE's seat — the KPIs with health, recent values and source, the one-step KPI editor,
// and (AGENT-REPORTING) each row's reporting duty. It replaced KPI-ASSIGN's own "KPIs" tab: the
// profile (de-profile.tsx) mounts this slot under its KPIs area. With `kpi` off it says so and
// calls no `kpi` route (ADR-0016); a DE without an active seat has no KPIs (they are per seat).
import { EmptyState } from "@companyos/ui";
import { GaugeIcon } from "lucide-react";
import type { Api } from "../../api/client";
import type { CompanyAccess } from "../company";
import { SeatKpisPanel } from "../kpi/seat-kpis";
import { Loading } from "../screen-parts";

export function DeKpisSlot({
  api,
  company,
  name,
  kpi,
  seat,
  pending,
  week,
}: {
  api: Api;
  company: CompanyAccess;
  name: string;
  kpi: boolean;
  /** The DE's active seat; null when it has none (or the profile is still loading). */
  seat: { id: string; title: string } | null;
  /** The profile is still loading. */
  pending: boolean;
  /** The focused ISO week, e.g. 2026-W43. */
  week: string;
}) {
  if (!kpi)
    return (
      <EmptyState
        variant="card"
        icon={GaugeIcon}
        data-slot="de-kpis-slot"
        title={`${name}'s KPIs`}
        description="KPIs need the KPI add-on."
      />
    );
  if (seat)
    return (
      <div data-slot="de-kpis-slot" className="min-w-0">
        <SeatKpisPanel
          api={api}
          company={company}
          seatId={seat.id}
          seatTitle={seat.title}
          holders={[{ name, kind: "digital_employee" }]}
          week={week}
        />
      </div>
    );
  if (pending) return <Loading label="Loading the KPIs" rows={4} />;
  return (
    <p className="text-sm text-muted-foreground" data-slot="de-kpis-slot">
      KPIs are kept per seat, and this DE has no active seat.
    </p>
  );
}
